import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"

export function ScheduleCommentaryMoveMenuItem({ onOpen }) {
    return <ContextMenuItem icon="mdi:folder-move-outline" label="Move" onClick={onOpen} />
}
